export interface NestedObject {
	[key: string]: string | string[];
}

export interface SerializeObject {
	[key: string]: string | number | boolean | NestedObject;
}

export const serialize = function (obj: SerializeObject): string {
	const searchParams = new URLSearchParams();
	for (const key in obj) {
		if (typeof obj[key] === "object" && obj[key] !== null) {
			const nestedObj = obj[key] as NestedObject;
			for (const iKey in nestedObj) {
				const value = nestedObj[iKey];
				if (Array.isArray(value)) {
					value.forEach((arrValue, index) => {
						if (arrValue !== "") searchParams.append(`filter[${iKey}][${index}]`, arrValue);
					});
				} else {
					if (value !== "") searchParams.append(`filter[${iKey}]`, value);
				}
			}
		} else if (obj[key] !== undefined && obj[key] !== null) {
			searchParams.append(`${key}`, String(obj[key]));
		}
	}
	return `?${decodeURIComponent(searchParams.toString())}`;
};
